<template>
  <div class="animated fadeIn">
    <b-row v-if="bought">
      <b-col sm="12" class="text-center">
        <h1>{{ t('packages_bought_title') }}</h1>
        <h2>{{ t('packages_bought_content') }}</h2>
      </b-col>
    </b-row>
    <b-row v-else-if="enabled">
      <b-col sm="12" class="text-center">
        <h1>{{ t('packages_already-subscription') }}</h1>
      </b-col>
    </b-row>
    <b-row v-else-if="!blocked">
      <b-col sm="12" v-if="deny">
        <b-alert variant="danger" class="text-center" show>{{ t('packages_fill-details') }}</b-alert>
      </b-col>
      <b-col sm="6" offset="3" v-if="discount === 1">
        <b-row>
          <b-col sm="9">
            <b-form-group>
              <b-form-input :placeholder="t('packages_write-coupon')" type="text" v-model="coupon"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-button variant="primary" block class="mr-1" @click="onApply()">
              {{ t('global_apply') }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="6" offset="3" v-else>
        <b-alert variant="success" class="text-center" show>{{ t('packages_coupon-applied') }}</b-alert>
      </b-col>
      <b-col sm="6" v-for="o in packages" v-bind:key="o.id">
        <b-card class="">
          <h1 slot="header" class="text-center">{{ t('packages_links').replace('{count}', o.count) }}</h1>
          <b-card-body class="text-center my-0 py-0">
            <s v-if="discount !== 1 && o.currency === 1">{{o.price.toFixed(2)}} PLN</s>
            <s v-if="discount !== 1 && o.currency === 2">{{o.price.toFixed(2)}} USD</s>
            <h2 v-if="o.currency === 1">{{(o.price * discount).toFixed(2)}} PLN</h2>
            <h2 v-if="o.currency === 2">{{(o.price * discount).toFixed(2)}} USD</h2>
          </b-card-body>
          <hr class="my-4">
          <b-row>
            <b-col sm="12">
              <b-button :disabled="deny" slot="footer" variant="success" class="my-1" block @click="onBuy(o.id, 'paypal')">{{ t('packages_buy-now') }} (PayPal)</b-button>
            </b-col>
            <b-col sm="12" v-if="o.currency === 1">
              <b-button :disabled="deny" slot="footer" variant="success" class="my-1" block @click="onBuy(o.id, 'dotpay')">{{ t('packages_buy-now') }} (DotPay)</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col sm="12" class="text-center">
        <h1>{{ t('packages_waiting_title') }}</h1>
        <h1 class="my-4"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></h1>
        <h2>{{ t('packages_waiting_content') }}</h2>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Packages",
  data() {
    return {
      coupon: "",
      discount: 1,
      deny: true,
      packages: [],
      blocked: false,
      enabled: false,
      bought: false
    };
  },
  methods: {
    onApply() {
      const coupon = this.coupon.trim();

      if (coupon === "") {
        Vue.swal(
          this.$translate.text("packages_please-enter-your-coupon"),
          "",
          "warning"
        );
      } else {
        const that = this;

        Vue.axios({
          method: "POST",
          url: "/coupon",
          data: {
            coupon
          },
          mode: "no-cors",
          withCredentials: true,
          credentials: "same-origin"
        })
          .then(response => {
            if (response.data.status) {
              that.discount = response.data.discount;
            } else {
              Vue.swal(
                this.$translate.text(
                  response.data.message
                    ? response.data.message
                    : "global_an-unexpected-error-occurred"
                ),
                "",
                "warning"
              );
            }
          })
          .catch(() => {
            Vue.swal(
              this.$translate.text("global_an-unexpected-error-occurred"),
              "",
              "warning"
            );
          });
      }
    },
    onBuy(id, type) {
      const that = this;
      this.blocked = true;

      Vue.axios({
        method: "POST",
        url: "/package/" + id + "/buy/" + type,
        data: {
          coupon: this.coupon
        },
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            window.location.href = response.data.url;
          } else {
            Vue.swal(
              this.$translate.text(
                response.data.message
                  ? response.data.message
                  : "global_an-unexpected-error-occurred"
              ),
              "",
              "warning"
            );
            that.blocked = false;
          }
        })
        .catch(() => {
          Vue.swal(
            this.$translate.text("global_an-unexpected-error-occurred"),
            "",
            "warning"
          );
          that.blocked = false;
        });
    }
  },
  beforeMount() {
    this.bought = !!this.$route.query.success;
    const that = this;

    Vue.axios({
      method: "GET",
      url: "/packages",
      params: {
        language: this.$translate.current
      },
      mode: "no-cors",
      withCredentials: true,
      credentials: "same-origin"
    })
      .then(response => {
        if (response.data.status) {
          that.deny = response.data.deny;
          //that.enabled = response.data.enabled
          that.packages = response.data.packages;
        } else {
          Vue.swal(
            this.$translate.text(
              response.data.message
                ? response.data.message
                : "global_an-unexpected-error-occurred"
            ),
            "",
            "warning"
          );
        }
      })
      .catch(() => {
        Vue.swal(
          this.$translate.text("global_an-unexpected-error-occurred"),
          "",
          "warning"
        );
      });
  }
};
</script>
